import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FilterProtocol } from '../../models/filterProtocol';

@Component({ standalone:false,
  selector: 'app-select-filter-protocol-dialog',
  templateUrl: 'select-filter-protocol-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['select-filter-protocol-dialog.component.scss']
})
export class SelectFilterProtocolComponent {
  title: string= "Select the filter to add a filter override";
  message: string = "Caution: By selecting the filter below, you will be changing the default filter behavior.";
  confirmButtonText = "Add Override";
  cancelButtonText = "Cancel";
  filterProtocols!: FilterProtocol[];
  selectedFilterProtocol?: FilterProtocol;

  constructor(@Inject(MAT_DIALOG_DATA) private data: any, private dialogRef: MatDialogRef<SelectFilterProtocolComponent>) {
    if(data){
        this.title=data.title || this.title;
        this.message = data.message || this.message;
        this.filterProtocols = data.filterProtocols;
        if (data.buttonText) {
            this.confirmButtonText = data.buttonText.ok || this.confirmButtonText;
            this.cancelButtonText = data.buttonText.cancel || this.cancelButtonText;
        }
    }
  }

  get canClickConfirm(): boolean{
    return this.selectedFilterProtocol!=undefined;
  }

  onConfirmClick(): void {
    this.dialogRef.close(this.selectedFilterProtocol);
  }
  onCancelClick(): void {
    this.dialogRef.close(undefined);
  }

}